// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__NjuAh","rootCenter":"LoadMoreObserver_rootCenter__3vAfH","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1uGCd"};